import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { AuthState } from './types'
import { RootState } from '../types'

export const state: AuthState = {
  connection: null,
  status: '',
  token: localStorage.getItem('ACCESS_TOKEN') || '',
  user: JSON.parse(String(localStorage.getItem('user'))),
  userData: {
    id: '',
    name: '',
    lastName: '',
    userName: '',
    avatarImage: '',
    isAdmin: false,
    isMonitoring: false
  },
  tokenValid: false,
  wsConnectionActive: false
}

const namespaced = true

export const authState: Module<AuthState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
